import { render, staticRenderFns } from "./modalEmployeeProviderId.vue?vue&type=template&id=22b658c4&"
import script from "./modalEmployeeProviderId.vue?vue&type=script&lang=js&"
export * from "./modalEmployeeProviderId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports